import React from "react"
import { 
  Circle,
  CircularSector,
  Svg,
} from "./styled"

const polarToCartesian = (centerX, centerY, radius, angleInDegrees) => {
  const angleInRadians = angleInDegrees * Math.PI / 180.0

  return {
    x: centerX + (radius * Math.cos(angleInRadians)),
    y: centerY + (radius * Math.sin(angleInRadians))
  }
}

const describeCountdownCircle = (x, y, radius, startAngle, endAngle) => {
  const start = polarToCartesian(x, y, radius, endAngle)
  const end = polarToCartesian(x, y, radius, startAngle)
  const arcSweep = endAngle - startAngle <= 180 ? "0" : "1"
  
  return [
    "M", start.x, start.y, 
    "A", radius, radius, 0, arcSweep, 0, end.x, end.y,
    "L", x,y,
  ].join(" ")
}

// NOTE: The "sector" in this component is drawn from the 12 o' clock 
//  position, clockwise. This means a countdown involves the sector GROWING, 
//  not shrinking, and as a result you'd want to set sectorColor to the colour 
//  you want to show progressively MORE as the count decreases - perhaps the 
//  opposite of what you might expect...
const CountdownCircle = ({ 
  angle, 
  bgColor,
  sectorColor,
}) => (
  <Svg viewBox={"0 0 100 100"}>
    <Circle 
      cx={50}
      cy={50}
      fillColor={bgColor} 
      r={50} 
    />
    {
      angle < 360 ? (
        <CircularSector 
          d={describeCountdownCircle(50, 50, 50, 0, angle)}
          fillColor={sectorColor}
        />
      ) : (
        <Circle 
          cx={50}
          cy={50}
          fillColor={sectorColor} 
          r={50}
        />
      )
    }
  </Svg>
)

export default CountdownCircle